import {DataFeedData,DataFeedPayData, VenueOwnerData} from "@/types/datafeed";
import { DataFeedState } from "@/types/store/adminzone";

export const state: DataFeedState = {
  datafeed: [] as Array<DataFeedData>,
  datafeedpayin:[] as Array<DataFeedPayData>,
  venueowners:[] as Array<VenueOwnerData>
}
